export default __webpack_public_path__ + "static/media/DefaultAppointType.c24f924f.svg";